import routerOptions0 from "/opt/build/repo/node_modules/.pnpm/nuxt@3.17.6_@netlify+blobs@9.1.6_@parcel+watcher@2.5.1_@types+node@24.0.14_@vue+compile_84ed17f6dd3822883a04282ac95e0260/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/opt/build/repo/app/router.options.ts";
const configRouterOptions = {
  scrollBehaviorType: "smooth",
  hashMode: false
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}